<template>
  <div
    class="user-chat w-100 overflow-hidden"
    :class="{'user-chat-show': showRoom}"
  >
    <div
      v-if="isRoomChatNotSelect"
      class="d-flex flex-column align-items-center justify-content-center wh-100"
    >
      {{ $t('room.chat_not_select') }}
    </div>
    <div
      v-else
      class="d-lg-flex"
    >
      <div
        class="overflow-hidden position-relative d-flex flex-column justify-content-center"
        style="width: 100%; height: 100vh;"
      >
        <room-header :room="room" />
        <div
          v-if="showText"
          class="flex-fill d-flex justify-content-center align-items-center p-3 p-lg-4"
        >
          <span v-if="isRoomLoading">{{ $t('room.loading') }}</span>
          <span v-else-if="isRoomEmpty">{{ $t('room.empty') }}</span>
        </div>
        <room-message-list
          v-else
          class="flex-fill"
        />
        <room-footer :room="room" />
      </div>
      <add-contact-box />
    </div>
  </div>
</template>

<script>
import {mapGetters, mapState} from "vuex";
import RoomHeader from "../components/Room/HeaderRoomComponents";
import RoomMessageList from "../components/Room/List/ListRoomComponents";
import RoomFooter from "../components/Room/FooterRoomComponents";
import AddContactBox from "../components/Room/Header/AddContact/BoxAddContactHeaderRoomComponents";

export default {
  components: {
    RoomFooter,
    RoomMessageList,
    RoomHeader,
    AddContactBox,
  },
  computed: {
    ...mapState('rooms', [
      'selectedRoomId',
      'rooms',
      'showRoom',
    ]),
    ...mapGetters('rooms', [
      'room',
    ]),
    ...mapState('room', [
      'loadingFirst',
      'messages',
    ]),
    isRoomChatNotSelect() {
      return Boolean(this.selectedRoomId) === false
    },
    isRoomLoading() {
      return Boolean(this.loadingFirst) === true
    },
    isRoomEmpty() {
      return Boolean(this.messages.length) === false
    },
    showText() {
      return (
        this.isRoomChatNotSelect ||
        this.isRoomLoading ||
        this.isRoomEmpty
      )
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
